export default "__VITE_ASSET__73b01a72__"